import React from 'react';
import './../../ui_core/templates/style/navigation.css';
import './style/navigation.css';
import {NavLink} from 'react-router-dom';

const navigation = () => {
    const isEditor = window.sessionStorage.getItem('isEditor');
    return (
        <div className="navWrapper">
            {isEditor !== null
                ? <ul className="linkList">
                    <li><NavLink exact to={{ pathname: '/', search: window.location.search }}
                                 className="statistic icon"/></li>
                    {isEditor === '1'
                        ? <li><NavLink to={{ pathname: '/schedule', search: window.location.search }}
                                       className="calendar icon"/></li>
                        : ''}
                    {isEditor === '1'
                        ? <li><NavLink to={{ pathname: '/priority', search: window.location.search }}
                                       className="priority icon"/></li>
                        : ''}
                    {isEditor === '1'
                        ? <li><NavLink to={{ pathname: '/test_sends', search: window.location.search }}
                                       className="bug icon"/></li>
                        : ''}
                    <li><NavLink to={{ pathname: '/info', search: window.location.search }}
                                 className="info icon"/>
                    </li>
                </ul>
                : ''}
        </div>
    );
};

export default navigation;
